/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMfrmProductOverviewData } from './mfrm-product-overview.data';
import { IMfrmProductOverviewProps } from './mfrm-product-overview.props.autogenerated';

export interface IMfrmProductOverviewViewProps extends IMfrmProductOverviewProps<IMfrmProductOverviewData> {

    productOverviewText: string;
}

/**
 *
 * MfrmProductOverview component
 * @extends {React.PureComponent<IMfrmProductOverviewProps<IMfrmProductOverviewData>>}
 */
class MfrmProductOverview extends React.PureComponent<IMfrmProductOverviewProps<IMfrmProductOverviewData>> {
    public render(): JSX.Element | null {
        let customDescription;
        if (this.props.data.productSpecificationData.result && this.props.data.productSpecificationData.result !== undefined) {
            const attributes = this.props.data.productSpecificationData.result;
            const customDescriptionAttributeKey = attributes[attributes.findIndex(obj => obj.Name === 'customDescription')];
            customDescription = customDescriptionAttributeKey?.TextValue ? customDescriptionAttributeKey?.TextValue : undefined;
        }

        const viewProps = {
            ...this.props,
            productOverviewText: customDescription ? customDescription :''
        };
        return this.props.renderView(viewProps);
    }
}

export default MfrmProductOverview;
